import { constants } from '../config';

const initialState = {
  done: false,
  loading: false,
  errorRequest: false,
  error: null,
  info: {},
};

export default function setWhoisReducer(state = initialState, action) {
  switch (action.type) {
    case constants.GET_WHOIS:
      return { ...state, loading: true, errorRequest: false, error: null };
    case constants.GET_WHOIS_SUCCESS: {
      return {
        ...state,
        loading: false,
        done: true,
        info: {
          ...action.payload,
        },
      };
    }
    case constants.GET_WHOIS_FAIL:
      return { ...state, loading: false, errorRequest: true, error: { ...action.error } };

    case constants.RESET_WHOIS:
      return initialState;
    default:
      return state;
  }
}
